/**
 * GlassPanel — the base primitive for all card-style UI elements.
 * Composes backdrop-blur + subtle border + rounded corners.
 *
 * Props:
 *   as       - HTML element to render (default: "div")
 *   children
 *   className - additional Tailwind classes
 *   ...rest  - forwarded to the element
 */
export function GlassPanel({ as: Tag = 'div', children, className = '', ...rest }) {
  return (
    <Tag
      className={[
        'backdrop-none',
        'border border-white/[0.07]',
        'rounded-2xl',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </Tag>
  );
}
